import React from 'react';
import CustomModal from '../../../../../../../components/CustomModal';
import { ITransportadorasVeiculos } from "../types/types.ts";
import Form from './Form/index.tsx';

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: ITransportadorasVeiculos;
  id_transportadora?: number;
}

const Create: React.FC<Props> = (props: Props) => {
  return (
    <CustomModal title={props.isEdit ? "Editar" : "Cadastrar"} onClose={props.onClear}>
      <Form isView={props.isView} selectedRow={props.selectedRow} onConfirm={props.onConfirm} isEdit={props.isEdit} onClose={props.onClear} id_transportadora={props.id_transportadora} />

    </CustomModal>
  );
}

export default Create;